export enum Role {
  PlatformAdmin = 'platform_admin',
  PlatformDeveloper = 'platform_developer',
  Syndic = 'condominium_manager',
  Caretaker = 'janitor',
  ViceSyndic = 'assistant_manager',
  FiscalCouncil = 'fiscal_council',
  AdvisoryCouncil = 'advisory_council',
  Administrator = 'property_manager',
  AdministratorCompany = 'administrator_company',
  Resident = 'resident',
  TechnicalSupport = 'maintenance',
  Freelancer = 'external_instructor',
  Gatehouse = 'gatehouse',
  LocalCommerce = 'local_commerce',
  Voting = 'voting',
  Polls = 'polls',
  ServiceProvider = 'service_provider',
}

export const RoleLabel: Record<Role, string> = {
  [Role.PlatformAdmin]: 'Administrador da Plataforma',
  [Role.PlatformDeveloper]: 'Desenvolvedor da Plataforma',
  [Role.Syndic]: 'Síndico',
  [Role.Caretaker]: 'Zelador',
  [Role.ViceSyndic]: 'Vice-Síndico',
  [Role.FiscalCouncil]: 'Conselho Fiscal',
  [Role.AdvisoryCouncil]: 'Conselho Consultivo',
  [Role.Administrator]: 'Administrador',
  [Role.AdministratorCompany]: 'Administradora',
  [Role.Resident]: 'Morador',
  [Role.TechnicalSupport]: 'Suporte Técnico',
  [Role.Freelancer]: 'Freelancer',
  [Role.Gatehouse]: 'Portaria',
  [Role.LocalCommerce]: 'Comércio Local',
  [Role.Voting]: 'Votação',
  [Role.Polls]: 'Enquetes',
  [Role.ServiceProvider]: 'Prestador de Serviços',
};

/**
 * Perfis que moram numa unidade. Só para eles a unidade é obrigatória — a
 * portaria e o prestador não moram aqui, e exigir unidade deles inventaria um
 * vínculo que não existe.
 */
export const ROLES_REQUIRING_UNIT = new Set<Role>([Role.Resident]);

export const ADMIN_USER_ROLE_OPTIONS: Role[] = [
  Role.Syndic,
  Role.ViceSyndic,
  Role.Caretaker,
  Role.FiscalCouncil,
  Role.AdvisoryCouncil,
  Role.Administrator,
  Role.AdministratorCompany,
  Role.Resident,
  Role.TechnicalSupport,
  Role.Freelancer,
  Role.Gatehouse,
  Role.ServiceProvider,
];

// Perfis que o síndico pode atribuir na tela de Cadastros de usuário.
// Prestador de Serviços fica de fora de propósito: tem tela e fluxo próprios.
export const SYNDIC_USER_ROLE_OPTIONS: Role[] = [
  Role.Syndic,
  Role.Caretaker,
  Role.ViceSyndic,
  Role.Resident,
  Role.FiscalCouncil,
  Role.AdvisoryCouncil,
  Role.TechnicalSupport,
  Role.Freelancer,
  Role.Administrator,
  Role.AdministratorCompany,
  Role.Gatehouse,
];

export const CNPJ_ELIGIBLE_ROLES = new Set<Role>([
  Role.Syndic,
  Role.TechnicalSupport,
  Role.Freelancer,
  Role.AdministratorCompany,
]);

export const isRole = (value: string): value is Role =>
  Object.values(Role).includes(value as Role);
